import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from "react-toastify";

const FacultyPage = () => {
  const [facultyData, setFacultyData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch staff data from API
  useEffect(() => {
    const fetchFaculty = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/staff`);
        console.log(response)
        setFacultyData(response.data.staff);
      } catch (error) {
        console.error("Error fetching staff:", error);
        toast.error("Failed to fetch staff data.");
      } finally {
        setLoading(false);
      }
    };

    fetchFaculty();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <p className="text-gray-600">Loading faculty data...</p>
      </div>
    );
  }

  const facultyWithPhotos = facultyData?.filter(faculty => faculty.profilePhoto);
  const rightColumnPhotos = facultyWithPhotos?.slice(0, 4);
  const bottomPhotos = facultyWithPhotos?.slice(4);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col p-4 sm:p-6 md:p-12">
      <header className="text-center mb-8">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">Faculty</h1>
        <p className="text-gray-700 mt-4 text-sm sm:text-base">
          SRGPC is equipped with distinguished professors having vast experience
          to nurture the talent of students.
        </p>
      </header>

      <div className="relative w-full flex flex-col lg:flex-row gap-8">
        {/* Table */}
        <div className="bg-white shadow-lg rounded-lg w-full lg:w-[90%] overflow-x-auto">
          <table className="table-auto w-full text-left border-collapse">
            <thead>
              <tr className="bg-[#00BFA5] text-white">
                <th className="px-8 py-1">S No.</th>
                <th className="px-8 py-1">Name</th>
                <th className="px-8 py-1">Qualification</th>
                <th className="px-8 py-1">Department</th>
                <th className="px-8 py-1">Specialization</th>
                <th className="px-8 py-1">Experience</th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {facultyData.length === 0 ? (
                <tr>
                  <td colSpan="6" className="py-4 px-6 text-center text-gray-500">
                    No faculty data available.
                  </td>
                </tr>
              ) : (
                facultyData?.map((faculty, index) => (
                  <tr key={faculty.id} className="border-b hover:bg-gray-50">
                    <td className="py-2 px-4">{index + 1}</td>
                    <td className="py-2 px-4">{faculty.name || "-"}</td>
                    <td className="py-2 px-4">{faculty.Qualification || "-"}</td>
                    <td className="py-2 px-4">{faculty.department || "-"}</td>
                    <td className="py-2 px-4">{faculty.Specialization || "-"}</td>
                    <td className="py-2 px-4">{faculty.Experience || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Right Column Images */}
        {rightColumnPhotos?.length > 0 && (
          <div className="flex flex-col lg:items-center gap-4">
            {rightColumnPhotos?.map((faculty, index) => (
              <div key={index} className="flex flex-col items-center">
                <img
                  src={faculty.profilePhoto ? `/api/uploads/staffimages/${faculty.profilePhoto}` : "/default-profile.jpg"}
                  alt={faculty.name}
                  className="w-40 h-56 object-cover shadow-lg rounded-lg"
                />
                <p className="mt-2 text-center text-gray-700 text-sm sm:text-base">
                  {faculty.name || "No Name"}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Bottom Images */}
      {bottomPhotos?.length > 0 && (
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 justify-center">
          {bottomPhotos?.map((faculty, index) => (
            <div key={index} className="flex flex-col items-center">
              <img
                src={faculty.profilePhoto ? `/api/uploads/staffimages/${faculty.profilePhoto}` : "/default-profile.jpg"}
                alt={faculty.name}
              />
              <p className="mt-2 text-center text-gray-700 text-sm sm:text-base">
                {faculty.name || "No Name"}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FacultyPage;
